<div class="redaction-flow-container">
    <!-- Header -->
    <div class="redaction-flow-header">
        <h1 class="dialog-title">
            Circuit Redactare Template
            <br /><span class="template-name">{{ data.name }}</span>
        </h1>
        <button class="btn btn-light close-button" type="button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Se incarca datele...</p>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="errorMessage && !isLoading">
        <mat-icon>error_outline</mat-icon>
        <p>{{ errorMessage }}</p>
        <button class="btn btn-primary" (click)="loadInitialData()">Reincearca</button>
    </div>

    <!-- Main Content -->
    <div class="redaction-flow-content" *ngIf="!isLoading && !errorMessage">
        <!-- Actions Header -->
        <div class="actions-header">
            <div class="header-info">
                <span class="info-text">
                    <mat-icon>info_outline</mat-icon>
                    Configureaza pasii de redactare pentru acest template. Trageti si plasati pentru reordonare.
                </span>
            </div>
            <button class="btn btn-add" *ngIf="canManage" (click)="addRedaction()">
                <mat-icon>add</mat-icon>
                Adauga pas
            </button>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!hasRedactions">
            <mat-icon>drafts</mat-icon>
            <h3>Niciun pas de redactare configurat</h3>
            <p>Adaugati pasi de redactare pentru a permite operatorilor sa editeze/revizuiasca documentele inainte de semnare.</p>
            <button class="btn btn-primary" *ngIf="canManage" (click)="addRedaction()">
                <mat-icon>add</mat-icon>
                Adauga primul pas
            </button>
        </div>

        <!-- Redaction Flow Timeline -->
        <div class="flow-timeline" *ngIf="hasRedactions">
            <!-- Start Node -->
            <div class="flow-node start-node">
                <div class="node-icon">
                    <mat-icon>play_circle</mat-icon>
                </div>
                <div class="node-label">Start</div>
            </div>

            <!-- Connector -->
            <div class="flow-connector"></div>

            <!-- Draggable Redaction List -->
            <div class="redaction-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
                <div class="redaction-card"
                     *ngFor="let redaction of flowData?.redactions; let i = index"
                     cdkDrag
                     [cdkDragDisabled]="!canManage">

                    <!-- Drag Handle -->
                    <div class="drag-handle" cdkDragHandle *ngIf="canManage">
                        <mat-icon>drag_indicator</mat-icon>
                    </div>

                    <!-- Card Header -->
                    <div class="card-header">
                        <div class="step-badge">
                            <span class="step-number">#{{ redaction.order }}</span>
                        </div>
                        <div class="type-badge" [ngClass]="getTypeClass(redaction.redaction_type)">
                            <mat-icon>{{ getTypeIcon(redaction.redaction_type) }}</mat-icon>
                            <span>{{ getTypeLabel(redaction.redaction_type) }}</span>
                        </div>
                        <button class="btn btn-delete" *ngIf="canManage" (click)="deleteRedaction(redaction)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                    <!-- Card Body -->
                    <div class="card-body">
                        <div class="form-row">
                            <!-- Tip Redactare -->
                            <div class="form-col form-col-type">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>Tip redactare *</mat-label>
                                    <mat-select [(ngModel)]="redaction.redaction_type"
                                                (selectionChange)="onRedactionTypeChange(redaction)"
                                                [disabled]="!canManage">
                                        <mat-option [value]="1">Editare + Upload</mat-option>
                                        <mat-option [value]="2">Review/Aprobare</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Functie (user_type) -->
                            <div class="form-col form-col-functie">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>Functia *</mat-label>
                                    <mat-select [(ngModel)]="redaction.user_type"
                                                (selectionChange)="onFunctieChange(redaction, i)"
                                                (opened)="onFunctieDropdownOpened(i)"
                                                (closed)="onDropdownClosed(i, 'functie')"
                                                [disabled]="!canManage"
                                                required>

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                                        *ngIf="functiiSearchControls[i]">
                                            <mat-label>Cauta functie...</mat-label>
                                            <input matInput
                                                   [formControl]="functiiSearchControls[i]"
                                                   (keydown)="$event.stopPropagation()"
                                                   (click)="$event.stopPropagation()"
                                                   autocomplete="off">
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredFunctiiByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au gasit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let functie of filteredFunctiiByIndex[i]"
                                                    [value]="functie.id">
                                            {{ functie.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="form-row">
                            <!-- Directie Dropdown with Typeahead -->
                            <div class="form-col">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>Directia *</mat-label>
                                    <mat-select [(ngModel)]="redaction.directie_id"
                                                (selectionChange)="onDirectieChange(redaction, i)"
                                                (opened)="onDirectieDropdownOpened(i)"
                                                (closed)="onDropdownClosed(i, 'directie')"
                                                [disabled]="!canManage"
                                                required>

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                                        *ngIf="directiiSearchControls[i]">
                                            <mat-label>Cauta directie...</mat-label>
                                            <input matInput
                                                   [formControl]="directiiSearchControls[i]"
                                                   (keydown)="$event.stopPropagation()"
                                                   (click)="$event.stopPropagation()"
                                                   autocomplete="off">
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredDirectiiByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au gasit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let directie of filteredDirectiiByIndex[i]"
                                                    [value]="directie.id_directie">
                                            {{ directie.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Compartiment Dropdown with Typeahead -->
                            <div class="form-col">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>Compartimentul *</mat-label>
                                    <mat-select [(ngModel)]="redaction.compartiment_id"
                                                [disabled]="!canManage || !redaction.directie_id"
                                                (selectionChange)="onCompartimentChange(redaction, i)"
                                                (opened)="onCompartimentDropdownOpened(i)"
                                                (closed)="onDropdownClosed(i, 'compartiment')"
                                                required>

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                                        *ngIf="compartimenteSearchControls[i]">
                                            <mat-label>Cauta compartiment...</mat-label>
                                            <input matInput
                                                   [formControl]="compartimenteSearchControls[i]"
                                                   (keydown)="$event.stopPropagation()"
                                                   (click)="$event.stopPropagation()"
                                                   autocomplete="off">
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredCompartimenteByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au gasit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let compartiment of filteredCompartimenteByIndex[i]"
                                                    [value]="compartiment.id_compartiment">
                                            {{ compartiment.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint *ngIf="!redaction.directie_id">Selectati mai intai o directie</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="form-row">
                            <!-- User Dropdown with Typeahead (Optional) -->
                            <div class="form-col">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>Utilizatorul implicit (optional)</mat-label>
                                    <mat-select [(ngModel)]="redaction.user_id"
                                                [disabled]="!canManage || !redaction.directie_id"
                                                (selectionChange)="onUserChange(redaction, i)"
                                                (opened)="onUserDropdownOpened(i)"
                                                (closed)="onDropdownClosed(i, 'user')">

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                                        *ngIf="usersSearchControls[i]">
                                            <mat-label>Cauta utilizator...</mat-label>
                                            <input matInput
                                                   [formControl]="usersSearchControls[i]"
                                                   (keydown)="$event.stopPropagation()"
                                                   (click)="$event.stopPropagation()"
                                                   autocomplete="off">
                                        </mat-form-field>

                                        <mat-option [value]="null">-- Fara utilizator implicit --</mat-option>

                                        <mat-option *ngIf="filteredUsersByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au gasit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let user of filteredUsersByIndex[i]"
                                                    [value]="user.id_user">
                                            {{ user.name || user.full_name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint *ngIf="!redaction.directie_id">Selectati mai intai o directie</mat-hint>
                                </mat-form-field>
                            </div>

                            <!-- Descriere -->
                            <div class="form-col">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>Descriere (optional)</mat-label>
                                    <input matInput
                                           [(ngModel)]="redaction.description"
                                           (blur)="saveRedaction(redaction)"
                                           [disabled]="!canManage"
                                           placeholder="Descriere pas...">
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Selected Values Summary -->
                        <div class="selection-summary" *ngIf="redaction.directie_id">
                            <span class="summary-item" *ngIf="redaction.functie_name">
                                <mat-icon>badge</mat-icon> {{ redaction.functie_name }}
                            </span>
                            <span class="summary-item" *ngIf="redaction.directie_name">
                                <mat-icon>business</mat-icon> {{ redaction.directie_name }}
                            </span>
                            <span class="summary-item" *ngIf="redaction.compartiment_name">
                                <mat-icon>meeting_room</mat-icon> {{ redaction.compartiment_name }}
                            </span>
                            <span class="summary-item" *ngIf="redaction.user_name">
                                <mat-icon>person</mat-icon> {{ redaction.user_name }}
                            </span>
                        </div>
                    </div>

                    <!-- Connector after each card -->
                    <div class="card-connector"></div>
                </div>
            </div>

            <!-- End Node -->
            <div class="flow-node end-node">
                <div class="node-icon">
                    <mat-icon>arrow_forward</mat-icon>
                </div>
                <div class="node-label">Trimite la Semnare</div>
            </div>
        </div>

        <!-- Legend -->
        <div class="flow-legend" *ngIf="hasRedactions">
            <div class="legend-title">Legenda tipuri:</div>
            <div class="legend-items">
                <div class="legend-item">
                    <span class="type-badge redaction-type-edit">
                        <mat-icon>edit_document</mat-icon>
                        Editare + Upload
                    </span>
                    <span class="legend-desc">Operatorul poate edita si incarca o noua versiune</span>
                </div>
                <div class="legend-item">
                    <span class="type-badge redaction-type-review">
                        <mat-icon>fact_check</mat-icon>
                        Review/Aprobare
                    </span>
                    <span class="legend-desc">Operatorul revizuieste si aproba fara a modifica</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Saving Indicator -->
    <div class="saving-indicator" *ngIf="isSaving">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Se salveaza...</span>
    </div>
</div>
